import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'duration' })
export class DurationPipe implements PipeTransform {
  transform(value: string): string {
    return this.millisecondsToStr(new Date(value).getTime());
  }

  millisecondsToStr(milliseconds: number): string {
    const currentTimeMilliseconds = new Date().getTime();
    const diff = currentTimeMilliseconds - milliseconds;

    // cater for future dates where the server timestamp is in the future
    if (diff <= 0) {
      return 'less than a second';
    }

    let temp: number = Math.floor(diff / 1000);
    const years: number = Math.floor(temp / 31536000);
    if (years) {
      return `${years} year${this.numberEnding(years)}`;
    }

    const days: number = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      return `${days} day${this.numberEnding(days)}`;
    }

    const hours: number = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${this.numberEnding(hours)}`;
    }

    const minutes: number = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${this.numberEnding(minutes)}`;
    }

    const seconds: number = temp % 60;
    if (seconds) {
      return `${seconds} second${this.numberEnding(seconds)}`;
    }

    return 'less than a second';
  }

  numberEnding(val: number): string {
    return val > 1 ? 's' : '';
  }
}
